import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amzn-redshift-details',
  templateUrl: './help-amzn-redshift-details.component.html',
  styleUrls: ['./help-amzn-redshift-details.component.scss']
})
export class HelpAmznRedshiftDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
